module.exports = __webpack_public_path__ + "static/media/drone-alt.a8a37e81.svg";